<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div
            class="card-header pb-0 d-flex justify-content-between align-items-center"
          >
            <h6>橫幅廣告列表</h6>
            <button
              class="btn btn-sm btn-success mb-0"
              @click="$router.push('/banners/new')"
              v-if="can('marketing.edit')"
            >
              新增橫幅
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      橫幅
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      連結
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      排序
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="banner in banners" :key="banner.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div>
                          <video
                            v-if="isVideo(banner.media_url)"
                            :src="banner.media_url"
                            class="avatar avatar-lg me-3 border-radius-lg"
                            style="object-fit: cover"
                          ></video>
                          <img
                            v-else
                            :src="banner.media_url || '/no-image.png'"
                            class="avatar avatar-lg me-3 border-radius-lg"
                            alt="banner"
                          />
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">
                            {{ banner.title || "無標題" }}
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ banner.link_url || "-" }}
                      </p>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        banner.sort_order
                      }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <soft-badge
                        :color="banner.is_active ? 'success' : 'secondary'"
                        variant="gradient"
                        size="sm"
                      >
                        {{ banner.is_active ? "啟用" : "停用" }}
                      </soft-badge>
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs me-3"
                        data-toggle="tooltip"
                        data-original-title="Edit banner"
                        @click="$router.push(`/banners/${banner.id}/edit`)"
                        v-if="can('marketing.edit')"
                      >
                        編輯
                      </a>
                      <a
                        href="javascript:;"
                        class="text-danger font-weight-bold text-xs"
                        data-toggle="tooltip"
                        data-original-title="Delete banner"
                        @click="deleteBanner(banner.id)"
                        v-if="can('marketing.edit')"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                  <tr v-if="banners.length === 0">
                    <td colspan="5" class="text-center py-4 text-secondary">
                      暫無資料
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftBadge from "@/components/SoftBadge.vue";
import request from "@/utils/request";
import { hasPermission } from "@/utils/permissions";

export default {
  name: "banners-table",
  components: {
    SoftBadge,
  },
  data() {
    return {
      banners: [],
      currentUser: JSON.parse(localStorage.getItem("user") || "{}"),
    };
  },
  methods: {
    can(permission) {
      return hasPermission(this.currentUser, permission);
    },
    async fetchBanners() {
      try {
        const response = await request.get("/api/admin/hero-banners");
        this.banners = response.data.data;
      } catch (error) {
        console.error("Failed to fetch banners", error);
      }
    },
    async deleteBanner(id) {
      if (!confirm("確定要刪除此橫幅嗎？")) return;

      try {
        await request.delete(`/api/admin/hero-banners/${id}`);
        this.fetchBanners(); // Refresh list
      } catch (error) {
        console.error("Failed to delete banner", error);
        alert("刪除失敗");
      }
    },
    isVideo(url) {
      if (!url) return false;
      const extension = url.split(".").pop().toLowerCase();
      return ["mp4", "webm", "ogg", "mov"].includes(extension);
    },
  },
  async created() {
    this.fetchBanners();
  },
};
</script>
